import { useAtom, useAtomValue } from 'jotai';
import { Checkbox } from '@carbon/react';
import { wellsLayerVisibilityAtom, wellsLayerFittedAtom } from './atoms';
import style from 'components/map/map.module.scss';

export const WellsLayerSelection = () => {
  const [isVisible, setVisible] = useAtom(wellsLayerVisibilityAtom);
  const fitted = useAtomValue(wellsLayerFittedAtom);

  return (
    <div className={style.titleArea}>
      <div className={style.allCheckBox}>
        <Checkbox
          id="dca-workspace-wells-all"
          labelText="DCA Workspace Wells"
          checked={isVisible}
          disabled={!fitted}
          onChange={(_evt: any, { checked }: { checked: boolean }) =>
            setVisible(checked)
          }
        />
      </div>
    </div>
  );
};
